/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingMenuSearchBoxState, GroundingMenuSearchBoxSlots } from './GroundingMenuSearchBox.types';
import { CopilotProvider } from '@fluentui-copilot/react-provider';

const customStyleHooks = {
  useSearchBoxStyles_unstable: undefined,
};

/**
 * Render the final JSX of GroundingMenuSearchBox
 */
export const renderGroundingMenuSearchBox_unstable = (state: GroundingMenuSearchBoxState): JSXElement => {
  assertSlots<GroundingMenuSearchBoxSlots>(state);

  return (
    <state.root>
      {/* Stop gap until https://github.com/microsoft/fluentai/issues/3189 is implemented. */}
      <CopilotProvider customStyleHooks={customStyleHooks}>{state.searchBox && <state.searchBox />}</CopilotProvider>
      {state.expandButton && <state.expandButton />}
    </state.root>
  );
};
